import {Popover} from "@headlessui/react";
import {MenuIcon, XIcon} from "@heroicons/react/outline";

export default function MenuButton({open}) {
  return (
    <div className="flex items-center md:absolute md:right-0 md:inset-y-0 xl:hidden">
      <Popover.Button
        className="-mx-2 rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:bg-gray-100 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-rose-500">
        <span className="sr-only">Open menu</span>
        {open ? <XIcon className="block h-6 w-6" aria-hidden="true"/> : <MenuIcon className="block h-6 w-6" aria-hidden="true"/>}
      </Popover.Button>
    </div>
  )
}
